import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

interface ScheduleAgentholidaysProps {
  userId: number;
  fromDate: string; // Format: YYYY-MM-DD
  toDate: string; // Format: YYYY-MM-DD
  startHour: string; // Format: HH:mm
  endHour: string; // Format: HH:mm
  overwrite?: boolean;
}
export async function scheduleAgentholidays({
  userId,
  fromDate,
  toDate,
  startHour,
  endHour,
  overwrite = false,
}: ScheduleAgentholidaysProps): Promise<{ data: any }> {
  const body = {
    user: userId,
    from_date: fromDate,
    to_date: toDate,
    start_hour: startHour,
    end_hour: endHour,
    overwrite: overwrite,
  };
  return axios.post(`${API_URL}/api/crm/agents-schedule/`, body);
}
